// Required-secrets manifest: the names a deployment must provide, and what each is for.
//
// Names and descriptions only — a VALUE never appears here, in the config, or in the
// bundle. `pack` emits this manifest so the customer's operators know exactly which
// secrets to create before starting the stack, and a missing one fails fast instead of
// surfacing as a runtime error.
import { z } from 'zod';
export const RequiredSecretSchema = z.strictObject({
    /** Environment-variable style name, e.g. ENTRA_CLIENT_SECRET. */
    name: z.string().regex(/^[A-Z][A-Z0-9_]*$/, 'must be UPPER_SNAKE_CASE'),
    /** What the secret is for, in the operator's words. */
    description: z.string().min(1),
    /** Which components read it, e.g. ["echo-control-plane", "echo-proxy"]. */
    usedBy: z.array(z.string().min(1)).min(1),
});
export const RequiredSecretsManifestSchema = z.strictObject({
    secrets: z.array(RequiredSecretSchema).default([]),
});
//# sourceMappingURL=required-secrets.js.map